export default "__VITE_ASSET__0459e662__"